


























import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {ProductDto} from '@eurogast/hub-client-typescript';
import AvailabilityEnum = ProductDto.AvailabilityEnum;

@Component
export default class AddToCartButton extends Vue {

  @Prop({required: true})
  public buttonClass: string;

  @Prop({required: true})
  public itemInCart: boolean;

  @Prop({required: true})
  public availability: AvailabilityEnum;


  @Prop({required: false, default: false})
  public isSmall: boolean;

  @Prop({required: false, default: null})
  public inCartIcon: string | null;

  @Emit()
  public cartAdd() {
  }

  @Emit()
  public cartRemove() {
  }

  private isPurchasable(): boolean {
    return this.availability === AvailabilityEnum.ACTIVE;
  }
}
